// Whether an attack path's stages form an unbroken chain in the org's own data. A stage "holds" when
// it has at least one OPEN finding (same rule as the backend's IsFullyTraversable); any stage without
// one is a gap — the data does not show a route through it. Used to say plainly when a path is
// incomplete instead of letting stages 1 and 4 with findings read as a full end-to-end route.
export function chainStatus(stages = []) {
  const ordered = [...stages].sort((a, b) => a.stageOrder - b.stageOrder);
  const open = ordered.filter(s => (s.openRiskCount || 0) > 0);
  const gaps = ordered.filter(s => !((s.openRiskCount || 0) > 0));
  return {
    ordered,
    openCount: open.length,
    total: ordered.length,
    complete: ordered.length > 0 && gaps.length === 0,
    openNames: open.map(s => s.stageName),
    gapNames: gaps.map(s => s.stageName),
  };
}

const list = names =>
  names.length <= 1 ? (names[0] || '') : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;

// One-sentence verdict for the selected path, or null when no stage has an open finding (nothing
// to explain — the path simply isn't present in the data).
export function chainVerdict(status) {
  if (status.openCount === 0) return null;
  if (status.complete) {
    return { tone: 'complete', text: 'Complete chain — every stage has an open finding, so your data shows an end-to-end route.' };
  }
  return {
    tone: 'incomplete',
    text: `Incomplete chain — ${status.openCount} of ${status.total} stages have open findings. ` +
      `No open findings at ${list(status.gapNames)}, so your data does not show an end-to-end route. ` +
      `The open findings at ${list(status.openNames)} still need fixing on their own.`,
  };
}
